import React from 'react';

export default function Modal({ baslik, onKapat, children, genislik }) {
  return (
    <div className="modal-overlay" onClick={onKapat}>
      <div className="modal" style={genislik ? { width: genislik } : undefined} onClick={(e) => e.stopPropagation()}>
        {baslik && <h3>{baslik}</h3>}
        {children}
      </div>
    </div>
  );
}
